/* eslint-disable jsx-a11y/role-supports-aria-props */

import * as React from "react"
import Flink from '~/components/shared/flink'
import { usePdp } from '~/contexts/PdpContext'

import * as styles from "~/styles/pdp/sizes_alts.module.scss"
import * as pdp_styles from "~/styles/pdp/pdp.module.scss"


const Alts = () => {
  const { product } = usePdp()
  const { is_gift, alt_cuts, handle } = product

  return (
    <div className="alt_cuts">
      <div className={[pdp_styles.info, pdp_styles.alts_info].join(' ')}>
        <div className={pdp_styles.label} id="ar_label-select_alt">
          {is_gift 
            ? 'Gift Type:'
            : `${alt_cuts.type}:`
          }
        </div>
      </div>

      <div 
        className={[styles.qsizes, styles.pdp_sizes].join(' ')}
        role="menu" 
        aria-labelledby="ar_label-select_alt"
      >
        {alt_cuts.opts.map( (opt, index) => {
          let opt_avail = opt.availableForSale
          const is_pdp = handle === opt.handle

          return (
            <React.Fragment key={`alts${alt_cuts.type}${index}`}>
              {opt_avail ? (
                <Flink 
                  className={`${styles.option} ${!opt_avail && styles.unavailable}`}
                  href={opt_avail ? `${handle !== opt.handle ? `/products/${opt.handle}` : ''}` : undefined}
                  aria-disabled={!opt_avail ? true : undefined}
                  aria-current={is_pdp ? 'true' : 'false'}
                  aria-label={is_pdp ? `${alt_cuts.type} ${opt.name} currently selected` : `Select ${alt_cuts.type} ${opt.label}`}
                  role="menuitem" 
                  tabIndex="-1"
                >
                  {opt.label}
                </Flink>
              ) : (
                <div 
                  className={`${styles.option} ${!opt_avail && styles.unavailable}`}
                  aria-disabled={'true'}
                  aria-current={is_pdp ? 'true' : 'false'}
                  aria-label={is_pdp ? `${alt_cuts.type} ${opt.name} currently selected` : `Select ${alt_cuts.type} ${opt.label}`}
                  role="menuitem" 
                  tabIndex="-1"
                >
                  {opt.label}
                </div>
              )}
              
            </React.Fragment>
          )
        })}
      </div>
    </div>

  )
}

export default Alts
